<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="M204-129q-30.94 0-52.97-22.03Q129-173.06 129-204v-552q0-30.94 22.03-52.97Q173.06-831 204-831h552q30.94 0 52.97 22.03Q831-786.94 831-756v552q0 30.94-22.03 52.97Q786.94-129 756-129H204Zm0-75h238.5v-552H204v552Zm313.5 0H756v-276H517.5v276Zm0-351H756v-201H517.5v201Z"/></svg>
</template>
